import React from "react";
import UniversalTarjetaCurso from "../../../../../../components/UniversalTarjetaCurso";
import ContenedorCarrusel from "../../../../../../components/ContenedorCarrusel/ContenedorCarrusel";

export default function SubCursos({
  vCursoFiltro = [],
  lastSearchText = "",
  hasSearched = false,
}) {
  // Si ya buscó y la lista está vacía, mostramos mensaje
  if (hasSearched && vCursoFiltro.length === 0) {
    return (
      <div data-figma-id="2469:46068" class="alerta-no-encontrar">
          <p
            data-figma-id="2469:45979"
            class="alerta-no-encontrar-cursos-texto-1 "
          >
            Lo sentimos, no hemos encontrado resultados para “Curso {lastSearchText}”
          </p>
          <div data-figma-id="2469:45980" class="frame-290009">
            <img
              class="file-1"
              src="../images/file-1.svg"
              data-figma-image-id="67f5c2d60b3f2b1fa6a0ffe5"
              alt=""
              data-figma-id="2469:46028"
              data-figma-image-hash="c657b7acce0455d1878dee5ea8f79879"
              loading="lazy"
            />
            <div
              data-figma-id="2469:45982"
              class="alerta-no-encontrar-cursos-contenido"
            >
              <p
                data-figma-id="2469:45983"
                class="alerta-no-encontrar-cursos-contenido-texto"
              >
                No existe en esta Plataforma, modifica tu búsqueda o prueba lo
                siguiente:
              </p>
              <div
                data-figma-id="2469:45984"
                class="alerta-no-encontrar-cursos-contenido-info"
              >
                <div
                  data-figma-id="2469:45985"
                  class="alerta-no-encontrar-cursos-info-1"
                >
                  <div data-figma-id="2469:46064" class="circulito-gris-claro">
                    <img
                      src="../images/Vector_3.svg"
                      data-figma-image-id="67f5c2d8405281f91e4dba11"
                      alt=""
                      data-figma-id="2469:46065"
                      data-figma-image-hash="cb50c9aa61f5c3c0ef583559b56541b2"
                      loading="lazy"
                    />
                  </div>
                  <p
                    data-figma-id="2469:45987"
                    class="alerta-no-encontrar-cursos-info-1-texto"
                  >
                    Asegúrate de que todas las palabras están escritas
                    correctamente
                  </p>
                </div>
                <div
                  data-figma-id="2469:45988"
                  class="alerta-no-encontrar-cursos-info-2"
                >
                  <div data-figma-id="2469:46066" class="circulito-gris-claro">
                    <img
                      src="../images/Vector_3.svg"
                      data-figma-image-id="67f5c2d8405281f91e4dba11"
                      alt=""
                      data-figma-id="2469:46067"
                      data-figma-image-hash="cb50c9aa61f5c3c0ef583559b56541b2"
                      loading="lazy"
                    />
                  </div>
                  <p
                    data-figma-id="2469:45990"
                    class="alerta-no-encontrar-cursos-info-2-texto"
                  >
                    Prueba con términos de búsqueda diferente
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }

  // Si hay resultados, los pintamos en el carrusel
  return (
    <ContenedorCarrusel
      vClassNameFlechaDer="botones-carrusel-derecha-a"
      vClassNameFlechaIzq="botones-carrusel-izquierda-a"
    >
      {vCursoFiltro.map((vCurso) => (
        <UniversalTarjetaCurso
          key={vCurso.id}
          vTipoRol="alumno"
          vIdCurso={vCurso.id}
          categorias={vCurso.categorias}
          nombreCurso={vCurso.nombre}
          numTotalLecciones={vCurso.total_lecciones}
          numTotalHoras={vCurso.duracion}
          precioCurso={vCurso.precio}
        />
      ))}
    </ContenedorCarrusel>
  );
}
